import { Link } from "react-router-dom";
import { Logo } from "./Logo";

export const LegalLayout = ({ title, updated, children, testId }) => (
    <div className="min-h-screen bg-[#F8FAFC]" data-testid={testId}>
        <header className="border-b border-gray-100 bg-white/90 backdrop-blur-xl">
            <div className="mx-auto flex h-16 max-w-4xl items-center justify-between px-6 lg:px-8">
                <Logo />
                <Link
                    to="/"
                    data-testid="legal-back-home"
                    className="text-sm font-medium text-[#4B5563] transition-colors hover:text-[#0B1F44]"
                >
                    Back to Home
                </Link>
            </div>
        </header>
        <main className="mx-auto max-w-4xl px-6 py-16 lg:px-8 lg:py-24">
            <h1 className="text-3xl font-bold tracking-tight text-[#0B1F44] lg:text-4xl">
                {title}
            </h1>
            <p className="mt-3 text-sm text-[#6B7280]">Last updated: {updated}</p>
            <div className="mt-12 space-y-10">{children}</div>
        </main>
    </div>
);

export const LegalSection = ({ title, testId, children }) => (
    <section data-testid={testId}>
        <h2 className="text-lg font-semibold text-[#0B1F44]">{title}</h2>
        <div className="mt-3 text-base leading-relaxed text-[#4B5563]">
            {children}
        </div>
    </section>
);

export const PlaceholderText = () => (
    <p>
        The full text for this section will be published here shortly. If you
        have any questions in the meantime, please contact us at{" "}
        <a
            href="mailto:admin@flowpilotops.co.uk"
            className="font-medium text-[#2563EB] hover:text-blue-700"
        >
            admin@flowpilotops.co.uk
        </a>
        .
    </p>
);
